import Ticket from '../../components/atoms/tickets/Ticket'
import PageHeadlineWithFourSteps from '../../components/molecules/headlines/PageHeadlineWithFourSteps'
import AccountIconWh24 from '../../components/atoms/account_icons/AccountIconWh24'

export default {
  components: {
    Ticket,
    PageHeadlineWithFourSteps,
    AccountIconWh24
  },
  data() {
    return {
      flowLineContents: {
        steps: ['作成', 'プレビュー', '確認', '完了'],
        activeStep: 2
      }
    }
  },
  methods: {
    clickLoginAndContinueButton() {
      dataLayer.push({
        event: 'signin_click',
        button: 'preview'
      })
    }
  }
}
